import { render, staticRenderFns } from "./TemporaryDeliveryDetails.vue?vue&type=template&id=14d28310&scoped=true"
import script from "./TemporaryDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./TemporaryDeliveryDetails.vue?vue&type=script&lang=js"
import style0 from "./TemporaryDeliveryDetails.vue?vue&type=style&index=0&id=14d28310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d28310",
  null
  
)

export default component.exports